import { Link } from "@inertiajs/react"

const tools = [
  { name: "Merge PDF", href: "/merge-pdf" },
  { name: "Split PDF", href: "/split-pdf" },
  { name: "Reorder PDF", href: "/reorder-pdf" },
  { name: "Protect PDF", href: "/protect-pdf" },
  { name: "Sign PDF", href: "/sign-pdf" },
  { name: "Image to PDF", href: "/image-to-pdf" },
  { name: "JPG to PDF", href: "/jpg-to-pdf" },
  { name: "PNG to PDF", href: "/png-to-pdf" },
]

const company = [
  { name: "About", href: "/about" },
  { name: "FAQ", href: "/faq" },
  { name: "Pricing", href: "/pricing" },
  { name: "Privacy Policy", href: "/privacy" },
  { name: "Terms of Service", href: "/terms" },
]

export function PublicFooter() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-muted/30 mt-16 border-t">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <span className="text-brand font-brand text-xl font-semibold">
              StitchPDF
            </span>
            <p className="text-muted-foreground mt-2 max-w-xs text-sm">
              Simple, fast PDF tools — merge, split, protect, and convert your
              files without the hassle.
            </p>
            <a
              href="https://www.betterlaunch.co"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-block"
            >
              <img
                src="https://www.betterlaunch.co/badge.svg"
                alt="Featured on Better Launch"
                width={140}
                height={38}
                className="h-auto w-[140px]"
              />
            </a>
            <p className="text-muted-foreground mt-4 text-sm">
              &copy; {currentYear} StitchPDF. All rights reserved.
            </p>
          </div>
          <div className="md:flex md:flex-col md:items-center">
            <div>
              <h3 className="text-sm font-semibold">Tools</h3>
              <ul className="mt-3 grid grid-cols-2 gap-x-8 gap-y-2">
                {tools.map((tool) => (
                  <li key={tool.href}>
                    <Link
                      href={tool.href}
                      className="text-muted-foreground hover:text-foreground focus-visible:ring-ring/50 rounded text-sm outline-none focus-visible:ring-[3px]"
                    >
                      {tool.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="md:ml-auto">
            <h3 className="text-sm font-semibold">Company</h3>
            <ul className="mt-3 space-y-2">
              {company.map((item) => (
                <li key={item.href}>
                  <Link
                    href={item.href}
                    className="text-muted-foreground hover:text-foreground focus-visible:ring-ring/50 rounded text-sm outline-none focus-visible:ring-[3px]"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </footer>
  )
}
